/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nsocheck
import React, { useEffect, useState } from 'react';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main';
import { ChannelPage } from '@/widgets/channel-page-widget-react';
import { ItemSpecVenusWidget } from '@/widgets/item-spec-venus-widget-react';
import { Acknowledgement } from '../Acknowledgement';

import * as S from './styles';
import { getWidgetData } from './getWidgetData';
import { FontSlider } from '../FontSlider';

interface ICompDataProps {
  fields: any[];
  layout: any[];
  dynamicLayout?: any[];
  previewLabel?: string;
  formLabel?: string;
  csmeSubLabel1?: string;
  csmeSubLabel2?: string;
  progressBarSteps?: string[];
  validatorConfig?: any;

  successIcon?: string;
  errorIcon?: string;

  userFormFields: any[];
  userFormLayout: any[];
  userFormTitle: string;
}

interface IRightEstablishmentFormProps {
  compData: ICompDataProps;
  currentStep: number;
  _initialData?: any;
  onAcknowledgement?(data: any, type: string): void;
  whoami?: string;
  acknowledgement: any;
  onFormSubmit?(formData: any): void;
  _changeTouchStatus?(val: any): void;
  changeStepHasError?(err: any): void;
  _changeCurrStep?(val: any): void;
  stepChange?(step: number, existingFormData: any): void;
  applicationNo?: string;
  fontScale: number;
  updateFontScale?(font: number): void;

  onPayClick?(appNo: string): void;
  type: string;
  onDraftSave?(formData: any, type: string, implicitSave?: boolean): void;
  draftData?: any;
}

export const RightEstablishmentForm = ({
  compData,
  currentStep,
  _initialData,
  onAcknowledgement,
  whoami,
  acknowledgement,
  onFormSubmit,
  _changeTouchStatus,
  changeStepHasError,
  _changeCurrStep,
  fontScale,
  updateFontScale,

  stepChange,
  applicationNo,
  onPayClick,
  type,
  onDraftSave,
  draftData,
}: IRightEstablishmentFormProps) => {
  const {
    fields,
    formLabel,
    previewLabel,
    layout,
    dynamicLayout,
    successIcon,
    errorIcon,
  } = compData;
  const [formFields, setFormFields] = useState([]);
  const [stateLayout, setStateLayout] = useState(layout);
  const [activeStep, setActiveStep] = useState(currentStep ?? 0);
  const [dynamicKey, setdynamicKey] = useState('first');
  const [touched, setTouched] = useState<any>({});
  const [tempKey, settempKey] = useState('');
  const [initialData, setinitialData] = useState(
    _initialData && Object.entries(_initialData)?.length > 0 ? _initialData : {}
  );
  const [stepHasError, setStepHasError] = useState<any>({});
  const [totalSteps, setTotalSteps] = useState(
    whoami === 'prospective_employee' ? 1 : 2
  );

  const tempData: any = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
  };

  useEffect(() => {
    setdynamicKey('first');
  }, [activeStep]);
  useEffect(() => {
    console.log('iuy->', currentStep, activeStep);
    setFormFields(fields[activeStep >= 1 ? 0 : activeStep]);
    window.scrollTo(0, 0);
  }, [activeStep]);

  useEffect(() => {
    setTotalSteps(whoami === 'prospective_employee' ? 1 : 2);
  }, [whoami]);

  useEffect(() => {
    setActiveStep(currentStep ?? 0);
  }, [currentStep]);

  const changeTouchStatus = (data: any, key: string) => {
    setTouched({ ...touched, [`${activeStep}-${dynamicKey}`]: true });

    console.log('pok->', tempKey, dynamicKey);
    settempKey(key);
  };
  useEffect(() => {
    if (touched[`${activeStep}-${dynamicKey}`]) {
      console.log('pok->', tempKey, dynamicKey);
      setdynamicKey(tempKey);
    }
  }, [touched]);

  const _renderHeader = (isPreview: boolean) => {
    console.log(`Preview label bla:`, isPreview);
    return (
      <div className="mt-2">
        {isPreview && (
          <h3 className="text-uppercase text-center">{previewLabel}</h3>
        )}
        <h4 className="text-center">{formLabel}</h4>
        {/* <h6 className="text-center">
          {isPreview
            ? subStep >= 1
              ? csmePreviewSubLabel2
              : csmePreviewSubLabel1
            : activeStep >= 1 && activeStep < 2
            ? csmeSubLabel2
            : csmeSubLabel1}
        </h6> */}
      </div>
    );
  };

  const profileData = {
    isLargeTitle: true,
    navItems: Object.entries(
      layout[activeStep >= 1 ? activeStep - 1 : activeStep]
    )?.map((_item: any) => {
      return {
        key: _item[0],
        // title: `${stepHasError[`${activeStep}-${_item[0]}`]} ${_item[1]?.label}`,
        title: (
          <>
            {stepHasError[`${activeStep}-${_item[0]}`] === true && (
              /* @ts-ignore */
              <S.Img src={errorIcon} fontScale={fontScale} />
            )}
            {(stepHasError[`${activeStep}-${_item[0]}`] === false ||
              (stepHasError[`${activeStep}-${_item[0]}`] === undefined &&
                touched[`${activeStep}-${_item[0]}`])) && (
              /* @ts-ignore */
              <S.Img src={successIcon} fontScale={fontScale} />
            )}
            {_item[1]?.label}
          </>
        ),
        link: `/${_item[0]}`,
        type: 'navbar',
      };
    }),
  };

  const updateInitialData = async (id: any, payload: any) => {};

  const _renderBody = () => {
    console.log(`In Rights of Est #1 :`, activeStep, currentStep, totalSteps);
    if (activeStep < totalSteps) {
      return (
        <>
          {_renderHeader(false)}{' '}
          <FontSlider fontScale={fontScale} updateFontScale={updateFontScale} />
          <div style={{ justifyContent: 'center', display: 'flex' }}>
            <div style={{ width: '80%' }}>
              <div className="bg-white rounded tweety-form-shadow">
                <ChannelPage
                  {...profileData}
                  activeKey={dynamicKey}
                  isNoProfileExist={true}
                  fontScale={fontScale}
                  onNavItemClick={(key: string) => {
                    changeTouchStatus(initialData, key);
                  }}
                />
                <TweetyWidget
                  labelColor={'#104382'}
                  fields={formFields}
                  layout={
                    stateLayout &&
                    stateLayout[
                      activeStep >= 1 ? activeStep - 1 : activeStep
                    ]?.[dynamicKey]?.data
                  }
                  onUpdateDynamicLayData={(data: any) =>
                    setinitialData({ ...initialData, ...data })
                  }
                  fontScale={fontScale}
                  allTouched={touched}
                  dynamicLayout={dynamicLayout}
                  key={`${
                    activeStep >= 1 ? activeStep - 1 : activeStep
                  }-${dynamicKey}`}
                  onChange={(id, payload) => updateInitialData(id, payload)}
                  onErrorFree={() => {
                    if (
                      stepHasError[`${activeStep}-${dynamicKey}`] ||
                      stepHasError[`${activeStep}-${dynamicKey}`] === undefined
                    ) {
                      setStepHasError({
                        ...stepHasError,
                        [`${activeStep}-${dynamicKey}`]: false,
                      });
                    }
                  }}
                  onHandleError={(val) => {
                    console.log('ki->');
                    setStepHasError({
                      ...stepHasError,
                      [`${activeStep}-${dynamicKey}`]: val,
                    });
                  }}
                  submitButtonLabel={'Next'}
                  renderSaveButton={true}
                  onDraftSave={(data) => onDraftSave && onDraftSave(data, type)}
                  onFormSubmit={(payload: any) => {
                    const formData = { ...initialData, ...payload };
                    setinitialData({ ...formData });
                    onDraftSave && onDraftSave(formData, type, true);
                    console.log(`testing bla ::`, activeStep, totalSteps);
                    if (
                      Object.entries(
                        layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                      )?.length === tempData[dynamicKey]
                    ) {
                      console.log(touched, 'ho->');
                      if (activeStep === totalSteps - 1) {
                        const allTouched = Object.entries(touched)?.filter(
                          (item) => !!item[1]
                        );
                        const allErrors = Object.entries(stepHasError)?.filter(
                          (item) => item[1]
                        );
                        let newTouched: any = {};
                        const total = Object.entries(
                          layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                        )?.length;
                        console.log(
                          'ho->so',
                          allTouched,
                          allErrors,
                          allTouched.length,
                          total,
                          total - (touched[dynamicKey] ? 0 : 1)
                        );
                        if (
                          allErrors?.length === 0 &&
                          allTouched.length ===
                            total -
                              (touched[`${activeStep}-${dynamicKey}`] ? 0 : 1)
                        ) {
                          Object.entries(
                            layout[
                              activeStep >= 1 ? activeStep - 1 : activeStep
                            ]
                          )?.forEach((item, key) => {
                            newTouched[`${activeStep}-${item[0]}`] = true;
                          });
                          _changeTouchStatus && _changeTouchStatus(newTouched);
                          setTouched({ ...newTouched });
                          settempKey('first');
                          changeStepHasError &&
                            changeStepHasError({
                              ...stepHasError,
                              [`${activeStep}-${dynamicKey}`]: false,
                            });
                          onFormSubmit && onFormSubmit({ ...formData });
                          stepChange &&
                            stepChange(activeStep + 1, { ...formData });
                          setActiveStep((activeStep) => activeStep + 1);
                        } else {
                          console.log('ho->');
                          let newTouched: any = {};
                          let err: any = {};
                          Object.entries(
                            layout[
                              activeStep >= 1 ? activeStep - 1 : activeStep
                            ]
                          )?.forEach((item, key) => {
                            newTouched[`${activeStep}-${item[0]}`] = true;
                            if (!touched[`${activeStep}-${item[0]}`]) {
                              if (
                                key ===
                                Object.entries(
                                  layout[
                                    activeStep >= 1
                                      ? activeStep - 1
                                      : activeStep
                                  ]
                                )?.length -
                                  1
                              ) {
                                err[`${activeStep}-${item[0]}`] = false;
                              } else {
                                err[`${activeStep}-${item[0]}`] = true;
                              }
                            }
                          });
                          setTouched(newTouched);
                          // console.log('ho->',stepHasError,err,{...stepHasError,...err});
                          setStepHasError({ ...stepHasError, ...err });
                          settempKey('first');
                          window.scrollTo(0, 0);
                        }
                        if (
                          activeStep == 3 &&
                          dynamicKey == 'third' &&
                          tempKey == 'third'
                        ) {
                          setActiveStep(4);
                          _changeCurrStep && _changeCurrStep(4);
                          // setCurrentStep(currentStep+1);
                          settempKey((tempKey) => tempKey + 1);
                        }
                      } else {
                        if (
                          activeStep == 3 &&
                          dynamicKey == 'third' &&
                          tempKey == 'third'
                        ) {
                          setActiveStep(4);
                          _changeCurrStep && _changeCurrStep(4);
                          settempKey((tempKey) => tempKey + 1);
                        } else setActiveStep((activeStep) => activeStep + 1);
                        stepChange &&
                          stepChange(activeStep + 1, { ...formData });
                        console.log('ho->');
                      }
                      //onNewWorkPermitNext && onNewWorkPermitNext(payload);
                    } else {
                      const ans = Object.entries(
                        layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                      )?.map((_item) => _item?.[0]);
                      const key = ans.indexOf(dynamicKey);
                      const temp = Object.entries(
                        layout[activeStep >= 1 ? activeStep - 1 : activeStep]
                      )?.[key + 1]?.[0];
                      setStepHasError({
                        ...stepHasError,
                        [`${activeStep}-${dynamicKey}`]: false,
                      });
                      changeTouchStatus(initialData, temp);
                      console.log('ho->');
                      window.scroll(0, 0);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (activeStep === totalSteps) {
      return (
        <>
          {_renderHeader(true)}

          {/* @ts-ignore */}
          <ItemSpecVenusWidget
            {...getWidgetData(fields, initialData)}
            onListClick={(item: any) => console.log(`item clicked`, item)}
            onPageChange={(event: any) => console.log(`page change`, event)}
            onSubmit={() => {
              onAcknowledgement && onAcknowledgement(initialData, type);
            }}
            onActionClick={(key, listId) =>
              console.log(`on action click`, key, listId)
            }
            whoAmI={whoami}
            // onItemClick={(itemId: string) => window.alert(itemId)}
          />
        </>
      );
    }
    if (activeStep === totalSteps + 1) {
      return (
        <Acknowledgement
          {...acknowledgement}
          onPayClick={onPayClick}
          applicationNo={applicationNo}
          submitBtnText={acknowledgement?.submitBtnText ?? ''}
        />
      );
    }
  };

  return <>{_renderBody()}</>;
};

RightEstablishmentForm.defaultProps = {
  // fields: [
  //   {
  //     type: 'text',
  //     compProps: {
  //       label: 'Last Name',
  //       id: 'lastName',
  //       placeholder: 'Enter Last Name',
  //       required: true,
  //     },
  //   },
  // ],
};
